import jquery from 'jquery';
window.$ = jquery;

import 'lazyload/lazyload.js';
// import 'jquery.smooth-scroll';

document.addEventListener("turbolinks:load", function () {
  let images = document.querySelectorAll('img.lazyload');
  lazyload(images, {
    rootMargin: '500px'
  });
});

document.addEventListener("turbolinks:load", function () {
  const scrollend = $('footer').offset().top;
  var distance = 0;
  $(document).scroll(function () {
    distance = $(this).scrollTop();
    if (scrollend <= distance) {
      $('.apply').fadeOut();
    } else {
      $('.apply').fadeIn();
    }
  });
});

document.addEventListener("turbolinks:load", function () {
  var pageTop = $('.to-apply')
  // pageTop.smoothScroll()
})

document.addEventListener("turbolinks:load", function () {
  const update = function () {
    const checked = $('input.js-policy-checkbox').toArray().every(function (item) {
      return $(item).prop('checked');
    });
    const button = $('.js-apply-button a');
    button.attr('href', checked ? button.data('url') : 'javascript:void(0);');
    $('.js-apply-button').toggleClass('disabled', !checked);
  };
  $(document).on('change', 'input.js-policy-checkbox', update)
  setTimeout(update, 100);
});
